import { useState, useEffect, useCallback, useContext, useRef } from 'react'
import PropTypes from 'prop-types'
import { PageContext } from './PageContext'
import { DataContext } from './DataProvider'

export const PageProvider = ({ children, activePage, setActivePage }) => {

  const [isResultsPage, setIsResultsPage] = useState(false)

  const [restMenuSubPages, setRestMenuSubPages] = useState(false)

  const initialPageSetRef = useRef(false)

  const dataContext = useContext(DataContext)

  // Add null check to prevent destructuring undefined during webpack rebuilds
  const { userDoc, checkedAuthenticated, hasActiveTournaments, activeTournamentPoolData } = dataContext || {}

  // Check for invite param in the URL on component mount and when userDoc changes
  useEffect(() => {
    // Only do initial page setting once, don't navigate on subsequent data changes
    if (initialPageSetRef.current) {
      console.log('INVITE_LOGS: PageProvider: Initial page already set, skipping navigation')
      return
    }

    // Only set the active page if we've checked authentication and have user data
    if (!checkedAuthenticated || !userDoc) {
      console.log('INVITE_LOGS: PageProvider: Waiting for authentication or user data - checkedAuthenticated:', checkedAuthenticated, 'userDoc:', !!userDoc)
      return
    }

    // Wait for tournament data to be loaded (activeTournamentPoolData is null/undefined initially, then becomes an array or empty array)
    if (activeTournamentPoolData === undefined) {
      console.log('INVITE_LOGS: PageProvider: Waiting for tournament data to load - activeTournamentPoolData:', activeTournamentPoolData)
      return
    }

    const urlParams = new URLSearchParams(window.location.search)
    const urlInviteParam = urlParams.get('invite')
    const storedInviteParam = sessionStorage.getItem('inviteParam')

    // Use stored invite parameter if URL doesn't have it
    const inviteParam = urlInviteParam || storedInviteParam

    console.log('INVITE_LOGS: PageProvider: Setting initial page - urlInviteParam:', urlInviteParam, 'storedInviteParam:', storedInviteParam, 'final inviteParam:', inviteParam, 'userDoc.hasSignedUp:', userDoc.hasSignedUp, 'hasActiveTournaments:', hasActiveTournaments)

    const urlParams2 = new URLSearchParams(window.location.search)
    const hasGolfInvite = urlParams2.get('inviteKey') && urlParams2.get('poolId')
    if (hasGolfInvite) {
      // MainLayout will navigate to GolfJoin page
      initialPageSetRef.current = true
      return
    } else if (inviteParam) {
      console.log('INVITE_LOGS: PageProvider: Setting active page to 4 (tournament)')
      setActivePage(2)
    } else if (hasActiveTournaments) {
      console.log('INVITE_LOGS: PageProvider: Setting active page to 3 (active tournaments)')
      setActivePage(3)
    } else {
      console.log('INVITE_LOGS: PageProvider: Setting active page to 2 (no active tournaments)')
      setActivePage(2)
    }

    // Mark that we've done the initial page setting
    initialPageSetRef.current = true
  }, [checkedAuthenticated, userDoc, hasActiveTournaments, activeTournamentPoolData, setActivePage]) //eslint-disable-line

  const handleMenuClick = useCallback((selectedPage, activePageId) => {
    if (selectedPage === 4) {
      setIsResultsPage(true)
    } else {
      setIsResultsPage(false)
    }

    if (selectedPage === activePageId) { // its worth noting that you cannot use activePage here. Possibly because of the context inside of a callback.
      setRestMenuSubPages(prev => !prev)
    }

    // Mark that initial page has been set when user manually navigates
    // This prevents the useEffect from overriding user navigation
    initialPageSetRef.current = true
    setActivePage(selectedPage)

  }, []) //eslint-disable-line

  return (
    <PageContext.Provider value={{ activePage, handleMenuClick, setActivePage, isResultsPage, restMenuSubPages }}>
      {children}
    </PageContext.Provider>
  )
}

PageProvider.propTypes = {
  activePage: PropTypes.number.isRequired,
  setActivePage: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}
